module.exports = __webpack_public_path__ + "static/media/bfm-www-movie-full.7d5bec16.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/video/bfm-www-movie-full.mp4
// module id = 566
// module chunks = 0